// src/components/management/AdminManagementPage.js

import React, { useState } from 'react';
import { createAdmin } from '../../services/apiService'; // Sesuaikan path jika perlu
import './AdminManagement.css'; // Buat file CSS ini untuk styling

function AdminManagementPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    role: 'kasir', // Nilai default untuk role
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null); // Bisa berupa string atau object
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccessMessage('');

    if (formData.password !== formData.password_confirmation) {
      setError({ general: 'Konfirmasi password tidak cocok.' });
      setIsLoading(false);
      return;
    }

    try {
      const response = await createAdmin(formData);
      setSuccessMessage(response.message || 'Admin berhasil dibuat!');
      // Reset form setelah berhasil
      setFormData({
        name: '', email: '', password: '', password_confirmation: '', role: 'kasir',
      });
    } catch (err) {
      console.error('Failed to create admin:', err);
      // apiService Anda sudah mengembalikan object error yang bagus
      setError({
        general: err.message, // Pesan error umum
        fields: err.errors,   // Pesan error spesifik per field dari validasi Laravel
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-management-page">
      <h2>Manajemen Admin</h2>
      <p>Hanya Super Admin yang dapat membuat admin baru.</p>

      <form onSubmit={handleSubmit} className="admin-form">
        <h3>Form Tambah Admin Baru</h3>

        {/* --- Menampilkan Pesan Error & Sukses --- */}
        {successMessage && <div className="form-message success">{successMessage}</div>}
        {error?.general && <div className="form-message error">{error.general}</div>}

        <div className="form-group">
          <label htmlFor="name">Nama Lengkap</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          {error?.fields?.name && <small className="field-error">{error.fields.name[0]}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {error?.fields?.email && <small className="field-error">{error.fields.email[0]}</small>}
        </div>
        
        <div className="form-group">
          <label htmlFor="role">Role</label>
          <select id="role" name="role" value={formData.role} onChange={handleChange} required>
            <option value="kasir">Kasir</option>
            <option value="server">Server</option>
            <option value="management">Management</option>
            <option value="super-admin">Super Admin</option>
          </select>
          {error?.fields?.role && <small className="field-error">{error.fields.role[0]}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            minLength="8"
          />
          {error?.fields?.password && <small className="field-error">{error.fields.password[0]}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="password_confirmation">Konfirmasi Password</label>
          <input
            type="password"
            id="password_confirmation"
            name="password_confirmation"
            value={formData.password_confirmation}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Menyimpan...' : 'Buat Admin'}
        </button>
      </form>
    </div>
  );
}

export default AdminManagementPage;